export default __webpack_public_path__ + "static/media/ic_volume_up_48px.0c7bdd8d.svg";